import React, { useEffect, useRef, useState } from 'react';
import { membershipPricingTableConfig } from './config/MembershipPricingTableConfig.data';
import FinalMolGrid from '../../components/FinalMolGrid/FinalMolGrid';
import Buttons from '../../components/ui/button/Buttons';
import { useAddEditMembershipPricingMutation, useLazyGetAllMembershipPricingQuery } from '../../app/services/MembershipPricing/MembershipPricingServiceApi';
import ToastService from '../../services/toastService/ToastService';
import { getAuditContext } from '../../lib/authenticationLibrary';

const MembershipPricingTableForm = () => {
  const pricingTableRef = useRef();
  const [pricingTable, setPricingTable] = useState([]);
  const audit = getAuditContext();
  const [getAllMembershipPricing, { isSuccess: isMembershipPricingSuccess, isFetching: isMembershipPricingFetching, data: membershipPricingData }] = useLazyGetAllMembershipPricingQuery();
  const [AddEditMembershipPricing, { isSuccess: isMembershipSuccess, isLoading: isMembershipLoading, data: savePricingResponse }] = useAddEditMembershipPricingMutation();

  useEffect(() => {
    if (!isMembershipPricingFetching && isMembershipPricingSuccess && membershipPricingData) {
      setPricingTable(membershipPricingData);
    }
  }, [isMembershipPricingFetching, isMembershipPricingSuccess, membershipPricingData]);

  useEffect(() => {
    if (!isMembershipLoading && isMembershipSuccess && savePricingResponse) {
      ToastService?.success("Pricing details saved successfully");
    }
  }, [isMembershipLoading, isMembershipSuccess, savePricingResponse]);

  useEffect(() => {
    getAllMembershipPricing();
  }, []);

  const handleSave = () => {
    let CreatedBy = audit?.adminUserId;
    let CreatedAppId = audit?.appId;

    const updatedData = pricingTable.map(item => ({
      ...item,
      CreatedBy,
      CreatedAppId
    }));

    let requst = {
      AddEditPricingDetails: updatedData
    }
    AddEditMembershipPricing(requst)
  };

  const handleEditClick = (data, rowIndex) => {
    let newGridData = [...pricingTable];
    newGridData[rowIndex] = { ...pricingTable[rowIndex], ...data };
    setPricingTable(newGridData);
  };

  const actionHandler = {
    EDIT: handleEditClick,
  };

  return (
    <div>
      <FinalMolGrid
        ref={pricingTableRef}
        dataSource={pricingTable}
        configuration={membershipPricingTableConfig}
        onRowDataUpdate={handleEditClick}
        allowPagination={false}
        onActionChange={actionHandler}
      />
      <Buttons
        onClick={handleSave}
        buttonTypeClassName="btn theme-btn my-2"
        buttonText={"Save"}
      />
    </div>
  );
};

export default MembershipPricingTableForm;
